import { AxiosError } from 'axios';
import { NextApiRequest, NextApiResponse } from 'next';
import { serverLogout } from './serverLogout';
import { serverRedirect } from './serverRedirect';
import { MessageType } from 'components/layouts/Toast';

export const handleAclErrorResponse = (
    res: NextApiResponse<any>,
    req: NextApiRequest,
    e: AxiosError
): void => {
    if (typeof e.response === 'undefined') {
        return;
    }

    const { status, data } = e.response;

    if (status === 503 || status === 502) {
        const redirect = req && !req.url.includes('redirect=') ? req.url : null;
        serverRedirect('/maintenance', res, undefined, redirect);
        return;
    }

    if (status <= 400 || status > 404) {
        return;
    }

    const message = data?.message;

    if (message === 'user_locked') {
        serverLogout(res, req, {
            message: 'user_locked_message',
            messageTitle: 'user_locked_title',
            messageType: MessageType.DANGER,
        });
        return;
    }

    if (status == 401) {
        if (
            message === 'user_not_found' ||
            message === 'refresh_token_name_not_found' ||
            message === 'access_token_name_not_found' ||
            message === 'missing_jwt_fields' ||
            message === 'token_expiration_not_found'
        ) {
            serverLogout(res, req);
        }
        return;
    }

    serverRedirect('/home', res, {
        message:
            status == 404 ? 'data_not_found_message' : 'not_access_message',
        messageTitle:
            status == 404 ? 'data_not_found_title' : 'not_access_message_title',
        messageType: MessageType.DANGER,
    });
};
